import { render, staticRenderFns } from "./WorkPackageListPage.vue?vue&type=template&id=a4c46b3a&scoped=true"
import script from "./WorkPackageListPage.vue?vue&type=script&lang=js"
export * from "./WorkPackageListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c46b3a",
  null
  
)

export default component.exports